/*
 *  Author: DL
 *  Date: 2020-12-16 11:05:45
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-16 16:26:06
 *  LastEditors: DL
 *  Description: Alter
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useCallback } from 'react';
import Button from '../Button';
import styles from './index.less';

function Alert(props) {
    const { message = '', visible = false, onOK = () => {}, onClose = () => {} } = props;

    const handleOnOk = useCallback(() => {
        onOK();
        onClose();
    }, [onOK, onClose]);

    return visible ? (
        <div className={styles.wrapper}>
            <div className={styles.contentWrapper}>
                <div className={styles.text}>{message}</div>
                <div className={styles.bttn}>
                    <Button type="primary" onClick={handleOnOk}>
                        确定
                    </Button>
                </div>
            </div>
        </div>
    ) : null;
}

export default Alert;
